import Screen from "controllers/Screen";
import Easing from "utils/Easing";
import Utils from "utils/Utils";
import Math_ from "utils/Math";
import * as PIXI from 'lib/pixi.js';
import Matter from "matter-js";
import AbstractHeader from "components/partials/interactive-header/js/AbstractHeader";


export default class ProjectsHeader extends AbstractHeader {
	constructor($wrapper) {
		super($wrapper);

		// DEBUG
		this.debug = false;

		if (this.debug) {
			this.$wrapper.addClass('debug');
		}

		/////// Shapes
		this.numShapes = 30;
		this.maxForce = Screen.wW * 0.0000001;

		// Matter group
		this.defaultCategory = 0x0001;

		this.init();
	}


	initEl() {
		super.initEl();
		this._initMatter();
	}


	_initMatter() {

		this.matterWidth = Screen.wW;
		this.matterHeight = Screen.wH;

		// create engine
		this.engine = Matter.Engine.create();
		this.world = this.engine.world;

		// create renderer
		if (this.debug) {
			this.render = Matter.Render.create({
				element: this.$wrapper[0],
				engine: this.engine,
				options: {
					background: 'transparent',
					wireframeBackground: 'transparent',
					wireframes: true,
					width: this.matterWidth,
					height: this.matterHeight,
					pixelRatio: 1,
					enabled: true
				}
			});
			Matter.Render.run(this.render);
		}
	}


	bindEvents() {
		this.onBeforeUpdateHandler = this.onBeforeUpdate.bind(this);
		Matter.Events.on(this.engine, 'beforeUpdate', this.onBeforeUpdateHandler);
		super.bindEvents();
	}


	unbindEvents() {
		Matter.Events.off(this.engine, 'beforeUpdate', this.onBeforeUpdateHandler);
		super.unbindEvents();
	}


	resize(isMobileH) {

		if (isMobileH) {
			return;
		}

		if (this.debug) {
			this.render.canvas.width = this.render.canvas.offsetWidth;
			this.render.canvas.height = this.render.canvas.offsetHeight;
		}

		this.numShapes = Math_.clamp(Math.round(Screen.wW * 0.03), 20, 50);
		this.numShapes = 100;
		this.maxForce = Screen.wW * 0.0000001;
		// this.numShapes = 1;

		this.killShapes(isMobileH);

		/// RECREATE ALL SHAPES
		for (let i = 0; i < this.numShapes; i++) {
			this.addShape(i);
		}

		super.resize();

	}


	raf() {
		super.raf();
		if (this.isVisible) {
			Matter.Engine.update(this.engine, 1000 / 60);
			this.drawShapes();
		}
	}


	onBeforeUpdate() {
		// Continuous wind
		for (let i = 0; i < this.shapes.length; i++) {
			// Same force for the entire shape
			const force = Matter.Vector.create(Matter.Common.random(-this.maxForce, this.maxForce), 0);
			/*if (i === 0) {
				console.log(maxForce, 2e-3);
			}*/
			for (let j = 0; j < this.shapes[i].rope.bodies.length; j++) {
				const body = this.shapes[i].rope.bodies[j];
				Matter.Body.applyForce(body, {x: body.position.x + Screen.wW, y: body.position.y}, force)
			}
		}
	}


	addShape(index) {

		// Matter group
		const matterGroup = Matter.Body.nextGroup();

		let shape = {},
			indexPercent = index / this.numShapes,
			// numCircles = (3 * (1 - indexPercent)) + 2,
			numCircles = 4,
			// startX       = ( Math.random() * 0.5 + 0.25 ) * Screen.wW,
			startX = Math.random() * Screen.wW,
			// startX       = 0.5 * Screen.wW,
			startY = -100,
			baseSize = Math.max(1, (Math.min(Screen.wH, Screen.wW) * 0.01)),
			radius = ((Math.random() * (baseSize * 1.25) + (baseSize * 0.75))) + (baseSize * 0.25);

		// MATTER
		const rope = Matter.Composites.stack(startX, startY, 1, numCircles, 0, Screen.wH / (numCircles + 1), (x, y, column, row, lastBody, bodyIndex) => {
			return Matter.Bodies.circle(x, y, radius, {
				collisionFilter: {
					mask: 0,
					// category: this.defaultCategory,
					// mask: this.mouseCategory
				}
			}, 10);
		});

		Matter.Composites.chain(rope, 0, 0.5, 0, -0.5, {
			stiffness: 1,
			length: Screen.wH / (numCircles + 1),
			render: {type: 'line'}
		});
		const firstRadius = (rope.bodies[0].bounds.max.y - rope.bodies[0].bounds.min.y) / 2;
		Matter.Composite.add(rope, Matter.Constraint.create({
			pointA: {x: rope.bodies[0].position.x, y: rope.bodies[0].position.y - firstRadius},
			bodyB: rope.bodies[0],
			pointB: {x: 0, y: -firstRadius},
			length: 10,
			stiffness: 1
		}));
		Matter.Composite.add(this.world, [rope]);

		shape.completion = 1 - (this.shapes.length / this.numShapes);
		shape.rope = rope;
		shape.graphics = new PIXI.Graphics();

		// Add child the graphics
		this.pxShape.addChild(shape.graphics);

		// Add to the shapes collection (in first position)
		this.shapes.push(shape);
	}


	/**
	 * KILL SHAPE
	 * ==========================================
	 * Kill all the shape tweens
	 * Remove from the collection
	 */
	killShape(shape) {
		Matter.Composite.remove(this.world, shape.rope);
		shape.graphics.clear();
		shape.graphics.destroy();
		shape.rope = null;
		shape.graphics = null;
		shape.completion = null;
		this.shapes.splice(this.shapes.indexOf(shape), 1);
		shape = null;
	}


	drawShapes() {

		// 2 . Loop through the shapes
		for (let shapeIndex = 0; shapeIndex < this.shapes.length; shapeIndex++) {

			const shape = this.shapes[shapeIndex],
				completion = shape.completion,
				num = shape.rope.bodies.length,
				points = [],
				radius = (shape.rope.bodies[0].bounds.max.x - shape.rope.bodies[0].bounds.min.x) * ((1 + this.scrollPercent * (1 - completion)));

			// TOP TO BOTTOM
			for (let pointIndex = 0; pointIndex < num; pointIndex++) {
				const body = shape.rope.bodies[pointIndex];

				points.push({
					x: body.position.x * this.shapesResolution,
					y: body.position.y * this.shapesResolution
				});
			}


			// RESET SHAPE AND BEGIN FILL
			shape.graphics.clear();
			// shape.graphics.beginFill(0xFFFFFF);
			shape.graphics.lineStyle({
				width: radius * this.shapesResolution,
				color: 0xFFFFFF,
				alpha: 1,
				alignment: 0.5,
				native: false,
				cap: PIXI.LINE_CAP.SQUARE,
				join: PIXI.LINE_JOIN.MITER
			});

			// STARTING POINT
			shape.graphics.moveTo(points[0].x, points[0].y);
			Utils.curveThroughPoints(points, shape.graphics);
			shape.graphics.endFill();


			const scrollScale = Easing.easeInQuint(1 - completion) * this.scrollPercent;

			shape.graphics.pivot.set(Screen.wW * this.shapesResolution, 0);
			shape.graphics.position.set(Screen.wW, (-this.virtualHeight * scrollScale));
			shape.graphics.scale.set(1 / this.shapesResolution, 1 / this.shapesResolution);

			// MASK TINT
			const colorRG = 32 + (Math_.clamp(Easing.linear(1 - completion) * this.introAlpha * (1 - this.scrollPercent), 0, 1) * (43 - 32)),
				colorB = 32 + (Math_.clamp(Easing.linear(1 - completion) * this.introAlpha * (1 - this.scrollPercent), 0, 1) * (226 - 32)),
				shapeHex = PIXI.utils.rgb2hex([colorRG / 255, colorRG / 255, colorB / 255]);
			shape.graphics.tint = shapeHex;
		}
	}

	destroy() {
		Matter.World.clear(this.engine.world);
		Matter.Engine.clear(this.engine);
		super.destroy();
	}

}
